<template>
    <!-- 轮播图 -->
    <div class="swiper-com">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" @change="onSwipeChange">
            <van-swipe-item v-for="item in currentBannerList" :key="item.id">
                <img :src="item.imgUrl" alt="" @click="handleBannerClick(item)">
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
import { getActivityIdFromRoute } from '@/utils/urlUtil';

export default {
    name:'swiper-com',
    props:['banner'],
    data() {
        return {
            // 定义不同活动ID对应的轮播图数据
            bannerConfigs: {
                // 默认轮播图（当没有活动ID时）
                default: [
                    // {
                    //     id: 1,
                    //     imgUrl: "https://img.zhujiaxian.com/2026/01/95f37e19eb9d42cd8e24819911f02bd4.png",
                    //     type: 'none'
                    // },
                    {
                        id: 2,
                        imgUrl: "https://img.zhujiaxian.com/2026/03/d68dc4b47206415c995426a70a1ad8ec.png",
                        type: 'product',
                        productId: '67949'
                    },
                    {
                        id: 3,
                        imgUrl: "https://img.zhujiaxian.com/2026/01/deba620f019a49a9bc99e1212d04d24b.png",
                        type: 'product',
                        productId: '65184'
                    },
                    {
                        id: 4,
                        imgUrl: "https://img.zhujiaxian.com/2026/01/95f37e19eb9d42cd8e24819911f02bd4.png",
                        type: 'product',
                        productId: '59424'
                    }
                ],
                // 活动ID为8时的轮播图
                8: [
                    {
                        id: 1,
                        imgUrl: "https://img.zhujiaxian.com/2025/08/e6b7891516f74dac8c2fe47934cafa36.jpg",
                        type: 'none'
                    }
                ],
                 // 活动ID为10时的轮播图
                10: [
                    {
                        id: 1,
                        imgUrl: "https://img.zhujiaxian.com/2025/09/be59575f20f249a4a85972b139b0c046.jpg",
                        type: 'none'
                    }
                ],
                 // 活动ID为9时的轮播图
                9: [
                    { 
                        id: 1,
                        imgUrl: "https://img.zhujiaxian.com/2025/09/f5d18a72d33a4926b2fee7ab9eadc510.png",
                        type: 'none'
                    }
                ],
                // 活动ID为13时的轮播图
                13: [
                    { 
                        id: 1,
                        imgUrl: "https://img.zhujiaxian.com/2025/11/7f9da10f42504ff29f54de0c8ec0471a.png",
                        type: 'none'
                    },
                    { 
                        id: 2,
                        imgUrl: "https://img.zhujiaxian.com/2025/11/09ded415ebfd4aeda7da4360e55268c4.png",
                        type: 'none'
                    }
                ],
                // 活动ID为12时的轮播图
                12: [
                    { 
                        id: 1,
                        imgUrl: "https://img.zhujiaxian.com/2025/11/b79ba1ce33ff41ad897c58b9f35f33aa.jpg",
                        type: 'none'
                    }
                ],
                // 活动ID为14时的轮播图（与ID 12相同）
                14: [
                    { 
                        id: 1,
                        imgUrl: "https://img.zhujiaxian.com/2025/11/b79ba1ce33ff41ad897c58b9f35f33aa.jpg",
                        type: 'none'
                    }
                ],
                // 活动ID为14时的轮播图（与ID 12相同）
                15: [
                    { 
                        id: 1,
                        imgUrl: "https://img.zhujiaxian.com/2025/12/1d2f6e9d14cc4c2ea552aaedc95b431d.jpg",
                        type: 'none'
                    }
                ],
                 // 活动ID为16时的轮播图（与ID 12相同）
                16: [
                    { 
                        id: 1,
                        imgUrl: "https://img.zhujiaxian.com/2026/01/f59cb8ced3064ea9afc30bcc2f4e722c.jpg",
                        type: 'none'
                    }
                ],
            },
            activityId: null
        }
    },
    computed: {
        // 从全局状态获取活动ID
        globalActivityId() {
          return this.$store.getters.getActivityId;
        },
        // 根据活动ID获取当前应该显示的轮播图列表
        currentBannerList() {
            // 如果有指定的活动ID配置，则使用该配置；否则使用默认配置
            if (this.activityId && this.bannerConfigs[this.activityId]) {
                return this.bannerConfigs[this.activityId];
            }
            return this.bannerConfigs.default;
        }
    },
    mounted() {
        // 从路由中获取活动ID
        const urlActivityId = getActivityIdFromRoute(this.$route);
        // 从全局状态获取活动ID
        const globalActivityId = this.$store.getters.getActivityId;
        
        // 如果URL中存在活动ID，优先使用URL中的活动ID
        if (urlActivityId) {
            this.activityId = urlActivityId;
            // 当URL中的活动ID与全局状态中的不同时，才更新全局状态
            if (urlActivityId !== globalActivityId) {
                this.$store.dispatch('updateActivityId', urlActivityId);
            }
        } else if (globalActivityId) {
            // URL中没有活动ID，但全局状态中有，使用全局状态中的活动ID
            this.activityId = globalActivityId;
        } else {
            // 既没有URL活动ID也没有全局活动ID时，使用默认设置
            this.activityId = null;
        }
        console.log('当前活动ID:', this.activityId);
    },
    methods:{
        onSwipeChange(index) {
            this.$emit('swiperChange', index);
        },
        toDetail(id){
            this.$router.push({
                path:'/productDetail',
                query:{
                    id
                }
            })
        },
        // 处理轮播图点击事件
        handleBannerClick(item) {
            if (item.type === 'product' && item.productId) {
                this.toDetail(item.productId);
            }
            // 可以根据需要添加其他类型的点击处理
        }
    }
}
</script>

<style lang="less" scoped>
    .swiper-com{
        // width: 100%;
        // margin: 0px 10px;
        text-align: center;
        img{
            width: 95%;
        }
    }
</style>
